import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";

import AOS from 'aos';
import 'aos/dist/aos.css';


const HomeTeam = () => {

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);


   useGSAP(() => {



   }, {});


   useEffect(() => {
      setInterval(() => {
         ScrollTrigger.refresh()
      }, [1500])

      AOS.init();
      AOS.refresh();

   }, [])


   return (
      <section className="IndSecSix" id="ourteam">
         <div className="container">
            <div className="ElearCmnHd text-center">
               <h2 data-aos='fade-left' data-aos-duration="1000">
                  <span className="tmTx1 noHl">Our</span> <span><span className="tmTx2">Team</span></span>
               </h2>
            </div>
            <div className="row">
               
               {/* Team Member 1: Pankaj Bhaban */}
               <div className="col-xl-4 col-md-6">
                  <div className="planCrdCmn">
                     <div className="HdrBac">
                        <div className="PlDts">
                           <div className="text-center ndmb-20">
                              <img src={require("../../../assets/images/prftm3.png")} alt="" />
                           </div>

                           <h2>Pankaj Bhaban</h2>
                           <h3>CTO & Co-Founder of Routine Coin </h3>
                           <h4></h4>
                           <p>
                              Pankaj Bhaban is a distinguished leader in blockchain technology and financial
                              trading systems, combining technical mastery with strategic vision. As the CTO of
                              Routine Coin, he drives innovation in blockchain-based solutions, leveraging his
                              expertise to advance decentralized technologies.
                           </p>
                           <p>
                              A proven pioneer in fintech, Pankaj founded Trendsignal V2.0, a premier platform
                              delivering algorithmic trading signals and strategies. His technical prowess is
                              recognized on MQL5, a global hub for automated trading developers, where he
                              contributes cutting-edge tools and insights.

                              With deep roots in cryptocurrency since 2015, Pankaj has engineered groundbreaking
                              crypto trading strategies and tools, bridging traditional finance and blockchain
                              ecosystems. His work underscores a rare blend of technical depth, adaptability, and
                              forward-thinking problem-solving.

                           </p>
                           <p>
                              Beyond his leadership roles, Pankaj actively engages global tech and trading
                              communities on platforms like GitHub, Facebook, and Quora, fostering collaboration
                              and knowledge-sharing. His contributions are further highlighted on prominent
                              financial market platforms, cementing his reputation as a transformative figure in
                              modern finance.

                           </p>

                        </div>
                     </div>
                     <div className="BdyBac">
                        <h2>Key Expertise</h2>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>
                              Blockchain Architecture
                           </p>
                        </div>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>
                              Algorithmic Trading Systems
                           </p>
                        </div>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>
                              Cryptocurrency Strategy Development
                           </p>
                        </div>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>
                              Fintech Innovation
                           </p>
                        </div>
                        <div className="text-center">
                           <a href="https://www.linkedin.com/in/pankaj-bhaban-48414067/" target="_blank" rel="noreferrer">
                              <img src={require("../../../assets/images/link.png")} className="img-fluid" alt="" />
                           </a>
                        </div>

                     </div>
                  </div>
               </div>

               {/* Team Member 2: Doz Khadri */}
               <div className="col-xl-4 col-md-6">
                  <div className="planCrdCmn">
                     <div className="HdrBac">
                        <div className="PlDts">
                          <div className="text-center ndmb-20">
                                 <img 
                                    src={require("../../../assets/images/red.png")} 
                                    alt="" 
                                    style={{ 
                                       width: "100px", 
                                       height: "100px", 
                                       borderRadius: "50%", 
                                       objectFit: "cover" 
                                    }}
                                 />
                                 </div>

                           <h2>Doz Khadri</h2>
                           <h3>Blockchain & Networking Professional</h3>
                           <h4></h4>
                           <p>
                              With extensive experience in the networking industry since 2006, Doz Khadri has been actively involved in the cryptocurrency and blockchain industry since 2018.
                           </p>
                           <p>
                              He holds a Professional Diploma in Blockchain & Decentralised Finance (DeFi) from UiTM Space, with a strong focus on community development, strategic networking, and exploring opportunities in blockchain technology and the digital economy.
                           </p>
                           <p>
                              Driven by a commitment to continuous growth and meaningful collaboration, Doz believes that true success is achieved when we create value, empower others, and grow together.
                           </p>
                        </div>
                     </div>
                     <div className="BdyBac">
                        <h2>Key Expertise</h2>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>BUILD NETWORKS</p>
                        </div>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>CREATE VALUE</p>
                        </div>
                        <div className="txntac">
                           <img className="dark-img" src={require("../../../assets/images/tick-circle.png")} alt="" />
                           <p>GROW TOGETHER</p>
                        </div>
                        <div className="text-center">
                           {/* ใส่ลิงก์ Social หรือ LinkedIn ของ Doz Khadri ตรงนี้ */}
                           <a href="#link" target="_blank" rel="noreferrer">
                              <img src={require("../../../assets/images/link.png")} className="img-fluid" alt="" />
                           </a>
                        </div>
                     </div>
                  </div>
               </div>

            </div>
         </div>
      </section>
   )
}
export default HomeTeam;